import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { smartscoreGrades } from '../utils';
import { ScoreIconComponent } from './score-icon.component';

@Component({
  selector: 'app-icon-info',
  standalone: true,
  imports: [CommonModule, IonicModule, ScoreIconComponent],
  template: `
    <div class="modalClose">
      <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
    </div>
    <ion-content>
      <ion-row>
        <ion-col class="text-center">
          <h2>Hva betyr symbolene?</h2>
          <p class="mx-4 mb-0">
            Symbolene representerer nivåer, og viser hvor smart du bruker strøm
            i forhold til andre strømkunder i ditt område. De sier noe om
            potensialet ditt til å spare penger ved å bruke strømmen på en
            smartere måte.
          </p>
        </ion-col>
      </ion-row>
      @for (x of grading; track $index) {
      <ion-row class="mx-4 my-8">
        <ion-col>
          <app-score-icon [score]="x.level"></app-score-icon>
          <p class="text-center m-0">
            <strong>{{ x.name }}</strong>
          </p>
          <p class="m-0">{{ x.description }}</p>
        </ion-col>
      </ion-row>
      }
    </ion-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconInfoComponent {
  grading = [...smartscoreGrades].reverse();

  constructor(public modalCtrl: ModalController) {}

  closeModal() {
    this.modalCtrl.dismiss();
  }
}
